import { NlpLogGroup } from '../../components/nlp/TrainingTab/types'
import { convertToNewLogGroup, isNewLogGroup } from '../../components/nlp/TrainingTab/utils'

export function transformLogGroupToNewGroupFormat(item: NlpLogGroup) {
  if (isNewLogGroup(item)) {
    return item
  }

  return convertToNewLogGroup(item)
}
